import { render, staticRenderFns } from "./PEHistory.vue?vue&type=template&id=2f89f3c0&"
import script from "./PEHistory.vue?vue&type=script&lang=js&"
export * from "./PEHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports